import React from 'react';
import LegalLayout from '../components/LegalLayout';

export function MentionsLegales() {
  return (
    <LegalLayout title="Mentions Légales">
      <section className="space-y-6">
        <p>
          Conformément aux dispositions des Articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique (L.C.E.N.), il est porté à la connaissance des utilisateurs du site superasso.fr les présentes mentions légales.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">1. Éditeur du site</h2>
        <p>Le site superasso.fr est édité par :</p>
        <p className="font-medium text-[#F5F3EE]">
          Nom : Sandro Teixeira<br />
          Statut : Micro-entreprise<br />
          Siège social : 4 rue de Langeot, 47200 Marmande, France<br />
          SIRET : 53231464800041<br />
          Email : contact@superasso.fr
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">2. Directeur de la publication</h2>
        <p>Le Directeur de la publication est : <span className="text-[#F5F3EE] font-medium">Sandro Teixeira</span>.</p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">3. Hébergement du site</h2>
        <p>Le site est hébergé par :</p>
        <p className="font-medium text-[#F5F3EE]">
          Google Cloud France (Firebase)<br />
          8 Rue de Londres, 75009 Paris, France.<br />
          Stockage des données : Europe (Région : europe-west9 - Paris)
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">4. Propriété intellectuelle</h2>
        <p>
          L'ensemble du contenu de ce site (logos, textes, éléments graphiques, code source) est la propriété exclusive de Sandro Teixeira, sauf mention contraire. Toute reproduction, même partielle, est strictement interdite sans autorisation préalable.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">5. Contact</h2>
        <p>Pour toute question, vous pouvez nous contacter à l'adresse : <span className="text-[#F9D965] font-bold">contact@superasso.fr</span></p>
      </section>
    </LegalLayout>
  );
}

export function Confidentialite() {
  return (
    <LegalLayout title="Confidentialité">
      <p className="italic text-sm opacity-60">Dernière mise à jour : 15 avril 2026</p>

      <section className="space-y-6">
        <p>
          La protection de vos données et de celles de vos membres est notre priorité. Cette politique détaille comment superasso.fr traite les données personnelles dans le respect du RGPD.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données est <span className="font-medium text-[#F5F3EE]">Sandro Teixeira</span>, situé au 4 rue de Langeot, 47200 Marmande.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">2. Données collectées</h2>
        <p>Dans le cadre de l'utilisation de notre SaaS, nous collectons :</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><span className="text-[#F5F3EE] font-medium">Données de compte :</span> Email, nom, prénom de l'administrateur de l'association.</li>
          <li><span className="text-[#F5F3EE] font-medium">Données associatives :</span> Informations relatives aux membres, cotisations et documents téléchargés par l'utilisateur (en tant que sous-traitant).</li>
          <li><span className="text-[#F5F3EE] font-medium">Données techniques :</span> Adresse IP (anonymisée), logs d'erreurs, comportement de navigation.</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">3. Outils tiers et transfert</h2>
        <p>Nous utilisons les prestataires suivants, tous conformes au RGPD :</p>
        <div className="grid gap-4">
          <div className="bg-white/5 p-4 rounded-2xl border border-white/10">
            <p className="font-bold text-[#F5F3EE] mb-1">Firebase (Google Cloud)</p>
            <p className="text-sm">Hébergement et authentification. Données à Paris.</p>
          </div>
          <div className="bg-white/5 p-4 rounded-2xl border border-white/10">
            <p className="font-bold text-[#F5F3EE] mb-1">Sentry</p>
            <p className="text-sm">Monitoring technique et suivi des bugs.</p>
          </div>
          <div className="bg-white/5 p-4 rounded-2xl border border-white/10">
            <p className="font-bold text-[#F5F3EE] mb-1">Resend</p>
            <p className="text-sm">Envoi d'e-mails au nom de l'association (newsletters, justificatifs, notifications).</p>
          </div>
          <div className="bg-white/5 p-4 rounded-2xl border border-white/10">
            <p className="font-bold text-[#F5F3EE] mb-1">Stripe</p>
            <p className="text-sm">Gestion des paiements sécurisée.</p>
          </div>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">4. Durée de conservation</h2>
        <p>
          Les données sont conservées tant que votre compte est actif. En cas de résiliation, les données associatives sont supprimées sous 30 jours, hors obligations légales.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-bold text-[#F9D965]">5. Vos droits</h2>
        <p>
          Accès, rectification, effacement et portabilité : contactez-nous à <span className="text-[#F9D965] font-bold">contact@superasso.fr</span>.
        </p>
      </section>
    </LegalLayout>
  );
}

export function CGU() {
  return (
    <LegalLayout title="CGU & CGV">
      <div className="max-w-3xl mx-auto">
        {/* Note: Remplacer ce bloc par votre composant LegalLayout si nécessaire */}
        <header className="mb-12 border-b border-[#F9D965]/20 pb-6">

          <p className="mt-2 text-sm text-gray-400">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
        </header>

        <div className="space-y-12">
          {/* Section 1 : Objet */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">1. Objet</h2>
            <p className="leading-relaxed">
              Les présentes conditions définissent les modalités d'accès et d'utilisation des services de
              <span className="text-[#F9D965] font-medium"> superasso.fr</span>, plateforme de gestion simplifiée pour les associations.
              L'utilisation du service implique l'acceptation pleine et entière des présentes conditions par l'utilisateur.
            </p>
          </section>

          {/* Section 2 : Offres et Évolutivité */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">2. Offres et Évolutivité</h2>
            <div className="space-y-3">
              <p>
                <span className="text-[#F5F3EE] font-bold">Plan Gratuit :</span> Accès illimité dans le temps. Certaines fonctionnalités et certains quotas de gestion (fiches, stockage,...) sont limités selon les conditions détaillées sur la plateforme.
              </p>
              <p>
                <span className="text-[#F5F3EE] font-bold">Offres Payantes :</span> Accès à des fonctionnalités avancées (Comptabilité, Communication, Administratif) selon les tarifs en vigueur indiqués sur la plateforme.
              </p>
              <p className="bg-[#F9D965]/5 p-4 border-l-4 border-[#F9D965] italic text-sm">
                SuperAsso se réserve le droit de modifier périodiquement les limites des offres et les tarifs.
                Toute modification majeure impactant un abonnement payant sera notifiée 30 jours avant son application.
              </p>
            </div>
          </section>

          {/* Section 3 : Modalités de paiement */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">3. Modalités de paiement</h2>
            <p>
              Le paiement est géré via la solution sécurisée <span className="font-medium text-[#F5F3EE]">Stripe</span>.
              Les abonnements sont prélevés mensuellement à la date anniversaire. Aucune coordonnée bancaire n'est stockée directement sur nos serveurs.
            </p>
          </section>

          {/* Section 4 : Responsabilité et Contenus */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">4. Responsabilité et Contenus</h2>
            <p>
              L'utilisateur est seul responsable de l'exactitude des données saisies et de la gestion légale de son association.
              En utilisant les outils de communication (Kit Presse, Pages de liens, Communiqués, autres...), l'association garantit détenir les droits de propriété intellectuelle des contenus (images, logos, textes) publiés.
            </p>
          </section>

          {/* Section 5 : Protection des données (RGPD) */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">5. Protection des données (RGPD)</h2>
            <div className="space-y-2">
              <p>
                L'association est "Responsable de traitement" et SuperAsso est "Sous-traitant".
                <span className="block mt-2 font-medium text-[#F5F3EE]">Nous ne commercialisons jamais vos données.</span>
              </p>
              <p className="text-sm text-gray-400">
                L'hébergement des données est assuré en Europe (Belgique/Francfort) via les infrastructures Firebase.
                L'association dispose d'un droit total d'exportation et de suppression de ses données.
              </p>
            </div>
          </section>

          {/* Section 6 : Résiliation */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">6. Résiliation</h2>
            <p>
              L'abonnement est sans engagement. L'interruption est possible à tout moment en un clic depuis le tableau de bord.
              L'accès aux services payants reste maintenu jusqu'à la fin de la période mensuelle entamée.
            </p>
          </section>

          {/* Section 7 : Disponibilité du service */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">7. Disponibilité du service</h2>
            <p>
              SuperAsso s'efforce d'assurer une disponibilité constante du service. Toutefois, s'agissant d'une plateforme évolutive,
              des interruptions pour maintenance technique ou mises à jour peuvent survenir.
              SuperAsso ne pourra être tenu responsable des conséquences d'une indisponibilité temporaire.
            </p>
          </section>

          {/* Section 8 : Droit applicable */}
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-[#F9D965]">8. Droit applicable</h2>
            <p>
              Les présentes conditions sont soumises au droit français. En cas de litige,
              compétence exclusive est attribuée aux tribunaux de <span className="font-medium text-[#F5F3EE]">Marmande</span>.
            </p>
          </section>
        </div>


      </div>
    </LegalLayout>
  );
}
